/* eslint-disable */
export const MockOfferTaken = {
  applianceCategory: 'Washing Machine',
  contact: {
    forename: 'SHABA',
    person_gid: '3697141',
    surname: 'MORETON-AAAQ',
  },
  deliveryAddress: {
    address_line_1: '28 HEPPLESTONE CLOSE',
    address_line_2: 'LONDON',
    address_line_3: 'LONDON',
    country_code: 'GBR',
    postal_code: 'SW15 5DE',
  },
  deliveryDate: '29/09/2020',
  make: 'Bosch',
  model: 'WAN28080GB',
  planNumber: 'ORB0000150',
  isProtectionSelected: false,
  isInstallationSelected: true,
  isDisposalSelected: false,
  deliveredBy: 'AO',
};
